import { validate, execute as graphqlExecute } from 'graphql';
import collegeEventSchema from '@purple/match-graphql-schema/lib/schema/college-event';
import collegeEventConnectors from '@purple/match-graphql-schema/lib/connectors/mocks/college-event';
import { ApolloLink, Observable } from 'apollo-link';

const { jwtDecode } = require('jwt-decode'); // eslint-disable-line import/no-extraneous-dependencies

async function execute(connectors, schema, document, rootValue, context, variableValues, operationName) {
  if (context) {
    context.connectors = {};
    if (connectors) {
      Object.keys(connectors).forEach((connectorName) => {
        const connector = connectors[connectorName];
        context.connectors[connectorName] = new connector(context);
      });
    }
    if (context.connectors.Features) {
      context.enabledFeatures = await context.connectors.Features.getEnabledFeatures(context.identityToken);
      if (process.env.REACT_APP_FEATURES_ON) {
        /* istanbul ignore next */
        context.enabledFeatures = context.enabledFeatures.concat(process.env.REACT_APP_FEATURES_ON.split(','));
      }
    }
  }
  const validationErrors = validate(schema, document);
  if (validationErrors.length > 0) {
    return { errors: validationErrors };
  }
  return graphqlExecute({
    schema,
    document,
    rootValue,
    contextValue: context,
    variableValues,
    operationName,
  });
}

function getContext(header) {
  if (header.authorization) {
    return { identityToken: jwtDecode(header.authorization.replace('Bearer ', '')) };
  } else {
    return {};
  }
}

export default function createLocalLink(rootValue) {
  return new ApolloLink(
    (operation) =>
      new Observable((observer) => {
        const start = new Date();
        const { headers } = operation.getContext();
        const { operationName, variables, query } = operation;
        const context = getContext(headers);
        Object.assign(context, { log: console });
        const result = execute(collegeEventConnectors, collegeEventSchema, query, rootValue, context, variables, operationName);
        result
          .then((data) => {
            console.log(`OPERATION: ${operationName} (${new Date() - start}ms)`); // eslint-disable-line no-console
            observer.next(data);
            observer.complete();
          })
          .catch(
            /* istanbul ignore next */ (err) => {
              console.error(`OPERATION: ${operationName} failed to execute (${err.message})`); // eslint-disable-line no-console
              observer.error(err);
            },
          );
      }),
  );
}
